// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--PmcIx","link":"a10a3f92e9--link--Bx07v","icon":"a10a3f92e9--icon--IpJqJ"};